export default __webpack_public_path__ + "static/media/alert-triangle.3787ce28.svg";